import { paginationQueryParsers } from '@ravago/shared/page-elements-radiance/components/content/product-portfolio/utils/product-search-nuqs-params';

import { useSearchParams } from 'next/navigation';
import { inferParserType } from 'nuqs';

import { paginationSerializer } from '../utils/pagination-serializer';

export const usePaginationSerializer = () => {
   const searchParams = useSearchParams();

   return (values: Partial<inferParserType<typeof paginationQueryParsers>>) => {
      const serialized = paginationSerializer(searchParams, values);
      return serialized || '?';
   };
};
